import _ from 'lodash';
import CMSModel from '@/visa-application/models/CMSModel';

export default class ConsentCMSModel implements CMSModel {
  status = '';
  consent_title = '';
  consent_sub_title = '';
  legal_information_title = '';
  customer_experience_survey_display = false;
  customer_experience_survey_default_value = false;
  customer_experience_survey_title = '';
  customer_experience_survey_description = '';
  customer_experience_survey_footer = '';
  marketing_communication_title = '';
  marketing_communication_tls = '';
  by_email_display = false;
  by_email_default_value = false;
  by_email = '';
  by_phone_display = false;
  by_phone_default_value = false;
  by_phone = '';
  by_sms_display = false;
  by_sms_default_value = false;
  by_sms = '';
  marketing_communication_from_trusted_partners = '';
  by_partners_display = false;
  by_partners_default_value = false;
  by_partners = '';
  marketing_communication_from_trusted_partners_footer = '';

  map(obj: any): void {
    this.status = _.get(obj, 'status', '');
    this.consent_title = _.get(obj, 'translation[0].consent_title', 'We value your privacy');
    this.consent_sub_title = _.get(
      obj,
      'translation[0].consent_sub_title',
      'We invite you to read and acknowledge the information below. All fields are required.'
    );
    this.legal_information_title = _.get(obj, 'translation[0].legal_information_title', 'Legal Information');
    this.customer_experience_survey_display = _.get(obj, 'customer_experience_survey_display', false);
    this.customer_experience_survey_default_value = _.get(obj, 'customer_experience_survey_default_value', false);
    this.customer_experience_survey_title = _.get(obj, 'translation[0].customer_experience_survey_title', 'Customer experience survey');
    this.customer_experience_survey_description = _.get(obj, 'translation[0].customer_experience_survey_description', '');
    this.customer_experience_survey_footer = _.get(obj, 'translation[0].customer_experience_survey_footer', '');
    this.marketing_communication_title = _.get(obj, 'translation[0].marketing_communication_title', 'Marketing & Communication');
    this.marketing_communication_tls = _.get(obj, 'translation[0].marketing_communication_tls', '');
    this.by_email_display = _.get(obj, 'by_email_display', false);
    this.by_email_default_value = _.get(obj, 'by_email_default_value', false);
    this.by_email = _.get(obj, 'translation[0].by_email', 'By e-mail');
    this.by_phone_display = _.get(obj, 'by_phone_display', false);
    this.by_phone_default_value = _.get(obj, 'by_phone_default_value', false);
    this.by_phone = _.get(obj, 'translation[0].by_phone', 'By phone');
    this.by_sms_display = _.get(obj, 'by_sms_display', false);
    this.by_sms_default_value = _.get(obj, 'by_sms_default_value', false);
    this.by_sms = _.get(obj, 'translation[0].by_sms', 'By SMS');
    this.marketing_communication_from_trusted_partners = _.get(obj, 'translation[0].marketing_communication_from_trusted_partners', '');
    this.by_partners_display = _.get(obj, 'by_partners_display', false);
    this.by_partners_default_value = _.get(obj, 'by_partners_default_value', false);
    this.by_partners = _.get(obj, 'translation[0].by_partners', 'By partners');
    this.marketing_communication_from_trusted_partners_footer = _.get(
      obj,
      'translation[0].marketing_communication_from_trusted_partners_footer',
      ''
    );
  }
}
